// extracted by mini-css-extract-plugin
export default {"desktopNav":"desktopNav__ZGViM","navLeft":"navLeft__YzY1O","navRight":"navRight__NzJkN","navLogoLink":"navLogoLink__OTE1M","navItems":"navItems__MDY2O","navItem":"navItem__YTQ2Y"};